import React from 'react';
import { motion } from 'framer-motion';
import { heroAnswer, heroPromise, heroPunchline } from '../../data/teaser';
import { OctImage } from '../OctImage';
const EASE = [0.23, 1, 0.32, 1] as const;
export function PromiseScreen() {
  return <div className="flex flex-1 flex-col" data-id="element-135" data-mp="13yoomc4qr5k4">
      <motion.h2 initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.28,
      ease: EASE
    }} className="font-display text-[26px] font-semibold leading-[1.1] text-navy" data-id="element-136" data-mp="18vot4ily0094">
        {heroPromise}
      </motion.h2>

      <motion.figure initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.3,
      delay: 0.1,
      ease: EASE
    }} className="mt-4 overflow-hidden rounded-xl border border-line" data-id="element-137" data-mp="21i9lnme5mie9">
        <OctImage revealed={['irf']} scanning hints drift className="w-full" data-id="element-138" data-mp="c561v58bi9bg" />
      </motion.figure>

      <motion.p initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.26,
      delay: 0.2,
      ease: EASE
    }} className="mt-4 text-[12.5px] leading-relaxed text-mut" data-id="element-139" data-mp="g7j9y0ajejbe">
        AI-assisted analysis of{' '}
        <span className="font-semibold tabular-nums text-navy" data-id="element-140" data-mp="16t5j08sul18t">2,355</span> DME eyes identified{' '}
        <span className="font-semibold text-navy" data-id="element-141" data-mp="1kopqm834lx0x">four distinct morphological phenotypes</span> from
        familiar OCT biomarkers.
      </motion.p>

      <motion.div initial={{
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.28,
      delay: 0.34,
      ease: EASE
    }} className="mt-auto pt-5" data-id="element-142" data-mp="1uo890k3e1aqv">
        <p className="font-display text-[21px] font-semibold leading-[1.14] text-navy" data-id="element-143" data-mp="24drnzenzckgg">
          {heroPunchline[0]}
        </p>
        <p className="font-display text-[21px] font-semibold leading-[1.14] text-blue" data-id="element-144" data-mp="1zgi2ga3posxw">
          {heroPunchline[1]}
        </p>
        <span className="sr-only" data-id="element-145" data-mp="28gemtzj2j5n5">{heroAnswer}</span>
      </motion.div>
    </div>;
}